import { useCallback, useState } from "react";

const STORAGE_KEY = "qalimo-tutorials-seen";

function readSeen(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((v) => typeof v === "string")
      : [];
  } catch {
    return [];
  }
}

/**
 * Vidéos déjà ouvertes par l'utilisateur, mémorisées dans le navigateur
 * (localStorage) : sert uniquement à distinguer « Nouveau » de « Vu ».
 */
export default function useSeenTutorials() {
  const [seenIds, setSeenIds] = useState<string[]>(readSeen);

  const markSeen = useCallback((id: string) => {
    setSeenIds((current) => {
      if (current.includes(id)) return current;
      const next = [...current, id];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // Stockage indisponible (navigation privée…) : l'état reste en mémoire.
      }
      return next;
    });
  }, []);

  return { seenIds, markSeen };
}
